import { storableError } from '../../util/errors';
import { addressFromListing } from '../../util/billing';

/**
 * La dirección del anuncio del anfitrión, para ofrecérsela como atajo.
 *
 * Se ofrece, no se rellena sola: **la dirección de la piscina no tiene por qué
 * ser el domicilio fiscal de quien la alquila**. Mucha gente alquila una casa
 * que no es donde está empadronada, y una factura con la dirección equivocada es
 * un problema de quien la recibe, no nuestro.
 *
 * Un bañista no tiene anuncios, así que para él esto no devuelve nada y el
 * atajo no llega a pintarse.
 */

// ================ Action types ================ //

export const FETCH_LISTING_ADDRESS_REQUEST = 'app/BillingDetailsPage/FETCH_LISTING_ADDRESS_REQUEST';
export const FETCH_LISTING_ADDRESS_SUCCESS = 'app/BillingDetailsPage/FETCH_LISTING_ADDRESS_SUCCESS';
export const FETCH_LISTING_ADDRESS_ERROR = 'app/BillingDetailsPage/FETCH_LISTING_ADDRESS_ERROR';

// ================ Reducer ================ //

const initialState = {
  listingAddress: null,
  fetchListingAddressError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTING_ADDRESS_REQUEST:
      return { ...state, fetchListingAddressError: null };
    case FETCH_LISTING_ADDRESS_SUCCESS:
      return { ...state, listingAddress: payload };
    case FETCH_LISTING_ADDRESS_ERROR:
      // Es un atajo opcional: si falla, la página sigue siendo utilizable.
      return { ...state, listingAddress: null, fetchListingAddressError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchListingAddressRequest = () => ({ type: FETCH_LISTING_ADDRESS_REQUEST });
export const fetchListingAddressSuccess = address => ({
  type: FETCH_LISTING_ADDRESS_SUCCESS,
  payload: address,
});
export const fetchListingAddressError = e => ({
  type: FETCH_LISTING_ADDRESS_ERROR,
  payload: e,
  error: true,
});

// ================ Thunks ================ //

export const fetchListingAddress = () => (dispatch, getState, sdk) => {
  dispatch(fetchListingAddressRequest());

  // Basta con uno: casi todo el mundo tiene un anuncio, y quien tenga varios
  // los tendrá casi siempre a su mismo nombre.
  return sdk.ownListings
    .query({ page: 1, perPage: 1 })
    .then(response => {
      const listing = response?.data?.data?.[0];
      dispatch(fetchListingAddressSuccess(addressFromListing(listing)));
      return response;
    })
    .catch(e => dispatch(fetchListingAddressError(storableError(e))));
};

export const loadData = () => dispatch => dispatch(fetchListingAddress());
